import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo">
          <img src={`${process.env.PUBLIC_URL}/images/LogoRem.png`} alt="IC Industries Logo" className='icind-header-logo' />
          <div className="logo-text">
            <div className="logo-main">IC INDUSTRIES</div>
            <div className="logo-subtitle">GAME AUDIO STUDIO</div>
          </div>
        </Link>
        
        <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/games" className="nav-link">Games</Link>
          <Link to="/about" className="nav-link">About</Link>
          <Link to="/sevendays" className="nav-link">7 Days</Link>
          <Link to="/download" className="nav-link">Download</Link>
          <Link to="/contact" className="nav-link">Contact</Link>
        </nav>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;